/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  list: [],
  filters: {
    id: [],
    status: [1, 2],
  },
  courses: [],
  classes: [],
  timetablesWithFilters: [],
  classesWithoutGroups: [],
  selecting: {},
  pagination: {},
};
